// The words the app uses, in one place.
// A listing is a "studio time", each date is a "session", a guest's purchase is a "booking".
// People are "artists" (who host) and "guests".
export const TERMS = {
    COURSE: 'Studio time',
    COURSES: 'Studio times',
    CLASS: 'Session',
    CLASSES: 'Sessions',
    TEACHER: 'Artist',
    TEACHERS: 'Artists',
    STUDENT: 'Guest',
    STUDENTS: 'Guests',
    BOOKING: 'Booking',
    BOOKINGS: 'Bookings',
    REGISTER_COURSE: 'List a studio time',
    APP_NAME: 'Studio Time',
};

export default TERMS;
